import mrpStyles from './../mrp.json'

export default {
  name: '3',
  color: mrpStyles.colors.SecondaryGreySky
}
